module.exports = __webpack_public_path__ + "static/media/java.86ad01aa.png";